module.exports = __webpack_public_path__ + "img/appIcon-apps--PaymentLinks.02bc741b.svg";